import {
	Report,
	ReportAction,
	ReportActionTypes as actionTypes,
	ReportUserPeriod,
	ResultReport
} from './reportTypes';

export const reportAddRequest = (payload?: Report): ReportAction => ({
	type: actionTypes.REPORT_ADD_REQUEST,
	payload
});

export const reportAddSuccess = (): ReportAction => ({
	type: actionTypes.REPORT_ADD_SUCCESS
});

export const reportAddFailure = (error: Error): ReportAction => ({
	type: actionTypes.REPORT_ADD_FAILURE,
	error
});

export const reportGetReportsRequest = (payload: {
	startDate: Date;
	endDate: Date;
	userEmail: string | string[];
	listId?: string;
	method?: string;
	listName?: string;
	locationId?: string;
}): ReportAction => ({
	type: actionTypes.REPORT_GET_REPORTS_REQUEST,
	payload
});

export const reportGetReportsSuccess = (
	payload: ResultReport
): ReportAction => ({
	type: actionTypes.REPORT_GET_REPORTS_SUCCESS,
	payload
});

export const reportGetReportsFailure = (): ReportAction => ({
	type: actionTypes.REPORT_GET_REPORTS_FAILURE
});

export const reportGetReportsClearState = (): ReportAction => ({
	type: actionTypes.REPORT_GET_REPORTS_CLEAR_STATE
});
